import { SetState } from 'zustand';
import { IHomeState } from './type';

export const homeActions = (set: SetState<IHomeState>) => ({
  increaseCount: () => set(prev => ({ count: prev.count + 1 })),
});
